import React from "react";
import Router from "./routes/Router";
import { ProSidebarProvider } from "react-pro-sidebar";
import { store } from "./store/store";
import { Provider } from "react-redux";
import TimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en.json'
import ru from 'javascript-time-ago/locale/ru.json'

TimeAgo.addDefaultLocale(en)
TimeAgo.addLocale(ru)
function App() {
  return (
    <Provider store={store}>
      <React.Fragment>
        <ProSidebarProvider>
          <div id="main-wrapper" className="show">
            <Router />
          </div>
        </ProSidebarProvider>
      </React.Fragment>
    </Provider>
  );
}

export default App;
